import React, { useState } from 'react';
import {useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../form/InputField';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import LoadingButton from '../../form/LoadingButton';
import SubmitButton from '../../form/SubmitButton';
import { toInputDateTimeLocal } from '../../../utils/toInputDateTimeLocal';

export interface LoyaltyFormFormData {
  endDate: string | null;
  startDate: string | null;
  amountRequired:number;
  bonusAmount:number
}

interface UpdateGiftTemplateFormProps {
  id: number;
  defaultValues: LoyaltyFormFormData;
  onSubmitSuccess:()=>void
}

function UpdateLoyaltyOfferForm({ id, defaultValues,onSubmitSuccess }: UpdateGiftTemplateFormProps) {
  const { t } = useTranslation();
  const { register, handleSubmit, watch, formState: { errors } } = useForm<LoyaltyFormFormData>({
    defaultValues: {
    startDate: toInputDateTimeLocal(defaultValues.startDate??"") ?? "",
    endDate:   toInputDateTimeLocal(defaultValues.endDate??"")   ?? ""
  }
  });


  const start = watch("startDate");

  const {loading,updateResource} = useUpdateResource();
      
        
    const onSubmit = async(data: LoyaltyFormFormData) => {
    let dataToSend :any={amountRequired:+data.amountRequired,bonusAmount:+data.bonusAmount};
    if(data.startDate){
        dataToSend.startDate = new Date( data.startDate).toISOString();
    }
        if(data.endDate){
        dataToSend.endDate = new Date( data.endDate).toISOString();
    }
    await updateResource(`loyalty-offer/${id}`, 
        {...dataToSend},
        "admin",{
            method: "PATCH",
            successMessage: t("updatedSuccess"),
            invalidateQueries: ["loyalty-offers-by-admin"],
            });
            onSubmitSuccess();
    };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
      <InputField
        placeholder=""
        label={t("amountRequired")}
        register={register("amountRequired")}
        type="number"
        error={errors.amountRequired}
        defaultValue={defaultValues.amountRequired}
      />

      <InputField
        placeholder=""
        label={t("bonusAmount")}
        register={register("bonusAmount")}
        type="number"
        error={errors.bonusAmount}
        defaultValue={defaultValues.bonusAmount}
      />
        {/* Start Date */}
        <InputField
          placeholder=""
          label={t("startDate")}
          register={register("startDate")}
          type="datetime-local"
          error={errors.startDate}
        />

        {/* End Date */}
        <InputField
          placeholder=""
          label={t("endDate")}
          register={register("endDate", {
            validate: (value) =>
              !value || !start || new Date(value) > new Date(start) || t("endDate_must_be_after_startDate")
          })}
          type="datetime-local"
          error={errors.endDate}
        />
      </div>


      {
        loading
        ?
        <LoadingButton/>
        :
        <SubmitButton label={t("update")}/>
    }
    </form>
  );
}

export default UpdateLoyaltyOfferForm;
